jQuery(function() {
    // Remove block-link class if exists
    $('.Banner-slider-box a').each(function() {
        if ($(this).hasClass('block-link')) {
            $(this).removeClass("block-link");
        }
    });

    // Initialize slick slider
    $('.Banner-slider-box').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 5000,
        dots: true,
        arrows: true,
        prevArrow: '<button class="slick-arrow slick-prev" aria-label="Previous slide"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 36 36" fill="none"><circle cx="18" cy="18" r="18" fill=""/><path d="M21 12L13 18.5L21 25" stroke="#B6637B" stroke-width="2" stroke-linecap="round"/></svg></button>',
        nextArrow: '<button class="slick-arrow slick-next" aria-label="Next slide"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 36 36" fill="none"><circle cx="18" cy="18" r="18" fill=""/><path d="M21 12L13 18.5L21 25" stroke="#B6637B" stroke-width="2" stroke-linecap="round"/></svg></button>',
    });

    // Update the available link class
    $(".Banner-slider-box a").each(function() {
        var index = parseInt($(this).attr("data-slick-index"));
        var max_index = parseInt($(".Banner-slider-box").attr("data-size"));
        if (index >= 0 && index < max_index) {
            $(this).addClass("available-link");
        }
    });

    // Redirect to href of available link on banner click
    $(document).on("click", ".custom-banner-box", function(event) {
        var link = $(this).find(".available-link[aria-hidden='false']").attr("href");
        //console.log(link)
        location.href = link;
    });

    // Stop propagation of click events on slick arrows
    $(document).on("click", ".slick-arrow", function(event) {
        event.stopPropagation();
    });
});